import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { get } from '../../api/usersModule/httpClient';
import { useDebounce } from '../../hooks/useDebounce';
import { useNavigate } from 'react-router-dom';
import { LargeCard } from '../Cards/LargeCard';
import { CDBModal } from "cdbreact";
import { ModalProviders } from "../Modals/ModalProviders";

const usersHeaders = ['Código Proveedor', 'Nombre', 'Ciudad', 'Dirección', 'Descripción', 'Usuario', "/providers"];

const defaultFormData = {
  selectedYear: '',
  selectedMonth: ''
};

export const CrudProviders = ({ userName, permissions, project }) => {
  const [data, setData] = useState([]);
  const [state, setState] = useState({ modal6: false });
  const [page, setPage] = useState(1);
  const [pressedButton, setPressedButton] = useState('');
  const [action, setAction] = useState('');
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 500);
  const navigate = useNavigate();
  const [totalItems, setTotalItems] = useState(0);
  const [initialRender, setInitialRender] = useState(true);
  const [changePage, setChangePage] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [statusNit, setStatusNit] = useState('');

  const [formData, setFormData] = useState({
    ...defaultFormData,
    user: userName,
  });

  const handleNavigateToSkus = (nit) => {
    navigate(`/skus`, { state: { nit } });
  };

  const fetchProjects = async (search, nit, statusPage) => {
    setLoading(true);
    let response;
    if (search != '') {
      response = await get(`/projects?page=${statusPage}&search=${search}&Nit=${nit}&limit=${itemsPerPage}`);
    } else {
      response = await get(`/projects?page=${statusPage}&Nit=${nit}&limit=${itemsPerPage}`);
    }
    setTotalItems(response.answer ? response.pagination.totalItems : 0);
    setData(response.items);
    setLoading(false);
  };

  const getReportProviders = async (nit) => {
    // Validar si tanto el año como el mes están llenos
    if (formData.selectedYear === '' || formData.selectedMonth === '') {
      // Mostrar una alerta con SweetAlert2 indicando que se deben seleccionar ambos
      formData.selectedYear = '';
      formData.selectedMonth = '';
      Swal.fire({
        icon: 'error',
        title: '¡Error!',
        text: 'Seleccione tanto el año como el mes antes de generar el reporte.',
        confirmButtonColor: '#146284',
      });
      return;
    }
  
    Swal.fire({
      title: 'Generando Reporte',
      text: 'Por favor, espere...',
      icon: 'info',
      allowOutsideClick: false,
      showCancelButton: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });
  
    const response = await get(`/projects?Nit=${nit}&reportProviders=${true}&selectedYear=${formData.selectedYear}&selectedMonth=${formData.selectedMonth}`);
  
    if (response.answer) {
      Swal.close();
      window.open(response.url, '_blank');
    } else {
      Swal.fire({
        icon: 'error',
        title: '¡Error!',
        text: 'Hubo un error al generar el reporte. Inténtelo de nuevo.',
      });
    }
  };

  const convertDataToArray = () => {
		try {
			return data.map((item) => [
				item.Nit.toUpperCase(),
        item.ProjectName.toUpperCase(),
        item.City.split(',')[0],
        item.ProviderAddress.toUpperCase(),
        item.ProjectDescription.charAt(0).toUpperCase() + item.ProjectDescription.slice(1).toLowerCase(),
        item.User.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')
			]);
		} catch (error) {
			console.error(error);
			return [];
		}
	};

  const toggle = (nr) => () => {
    const modalNumber = "modal" + nr;
    setState({ ...state, [modalNumber]: !state[modalNumber] });
  };

  const closeModal = () => {
    setState({ ...state, modal6: false });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };
  
  

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }

    if (!changePage) {
      fetchProjects(debouncedSearch, project, page);
    }else {
      setChangePage(false)
    }
  }, [page, initialRender]);

  useEffect(() => {
    fetchProjects(debouncedSearch, project, 1);
    setChangePage(true);
    setPage(1)
  }, [debouncedSearch]);

  useEffect(() => {
    fetchProjects(debouncedSearch, project, 1);
    setChangePage(true);
    setPage(1)
  }, [itemsPerPage]);

  useEffect(() => {

    switch (pressedButton.split(',')[0]) {
      case 'edit':
        handleNavigateToSkus(pressedButton.split(',')[1]);
        break;
      case 'refresh':
        setData([]);
        fetchProjects('', project, page);
        break;
      case 'monthlyReport':
        setAction("monthlyReport");
        setStatusNit(project);
        toggle(6)();
        break;
      case 'individualMonthlyReport':
        setAction("individualMonthlyReport");
        setStatusNit(pressedButton.split(',')[1]);
        toggle(6)();
        break;
      case "closeModal":
        if (state.modal6) {
          toggle(6)();
        }
        break;
      case "submitModal":
        getReportProviders(statusNit);
        toggle(6)();
        formData.selectedYear = '';
        formData.selectedMonth = '';
        break; 
      default:
        break;
    }
    setPressedButton('');
  }, [pressedButton]);

  const handleSetPressedButton = (button) => {
    setPressedButton(button);
  };

  return (
    <>
      <LargeCard
        name='Proveedores'
        headers={[...usersHeaders]}
        loading={loading}
        data={convertDataToArray()}
        totalItems={totalItems}
        customTable={false}
        setPage={setPage}
        page={page}
        setChangePage={setChangePage}
        setPressedButton={handleSetPressedButton}
        setSearch={setSearch}
        cState={false}
        providerState={true}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
      />

      <CDBModal isOpen={state.modal6} toggle={toggle(6)}>
        <ModalProviders
          action={action}
          setPressedButton={setPressedButton}
          closeModal={closeModal}
          formData={formData}
          handleChange={handleChange}
        />
      </CDBModal>
    </>
  );
};

export default CrudProviders;